import { authLog, authTrail, fingerprint } from 'src/sentry';

export const postToApp = (type, data = {}) => {
  if (window.ReactNativeWebView) {
    authTrail('postToApp', { type, ...('token' in data ? { tokenFp: fingerprint(data.token) } : {}) });
    window.ReactNativeWebView.postMessage(JSON.stringify({ type, ...data }));
  }
};

const REQUEST_FROM_APP_TIMEOUT_MS = 5000;

// monotonic id so a request and its response/timeout line up in the Sentry trail
let requestSeq = 0;

export const requestFromApp = (type, { timeout = REQUEST_FROM_APP_TIMEOUT_MS } = {}) => {
  if (!window.ReactNativeWebView) return Promise.resolve({});
  return new Promise((resolve) => {
    let timer;
    requestSeq += 1;
    const reqId = requestSeq;
    const startedAt = Date.now();

    // single teardown for both the success and timeout paths
    function cleanup() {
      clearTimeout(timer);
      window.removeEventListener('message', handleMessage);
      document.removeEventListener('message', handleMessage);
    }

    function handleMessage(event) {
      try {
        const data = JSON.parse(event.data);
        if (data.type === type) {
          cleanup();
          authTrail('requestFromApp:response', {
            reqId,
            type,
            durationMs: Date.now() - startedAt,
            hasToken: !!data.token,
            tokenFp: fingerprint(data.token),
          });
          resolve(data);
        }
      } catch (e) {
        // Non-JSON message, ignore.
      }
    }

    // if the app never answers, stop listening and resolve empty so callers don't hang
    timer = setTimeout(() => {
      cleanup();
      // timeouts can cascade into token clears after 401s, so make them searchable
      authLog('requestFromApp:timeout', { reqId, type, durationMs: Date.now() - startedAt });
      resolve({});
    }, timeout);

    authTrail('requestFromApp:start', { reqId, type });
    window.addEventListener('message', handleMessage);
    document.addEventListener('message', handleMessage);
    postToApp(type);
  });
};
